import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { EmptyState } from "@/components/EmptyState";
import { Flag } from "lucide-react";
import { resolveFederationLogo } from "@/lib/photoFallback";

export default function FederationsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/federations", { params: { limit: 100 } }).then((r) => setItems(r.data.items || [])); }, []);
  return (
    <div className="mx-auto w-full max-w-7xl px-3 sm:px-6 lg:px-8 py-6 sm:py-8">
      <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold">Fédérations</h1>
      <p className="text-sm text-muted-foreground mt-1">Les fédérations sportives polynésiennes.</p>
      <div className="mt-6">
        {items.length === 0 ? <EmptyState icon={Flag} title="Fédérations à venir." description="Les fédérations du COPF créeront leur page officielle ici (badge Vérifié par fédération)." /> :
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
            {items.map((f) => (
              <Link key={f.id} to={`/federations/${f.slug || f.id}`} data-testid="federation-card" className="min-w-0">
                <Card className="p-3 sm:p-4 aito-card-hover flex items-center gap-3 h-full">
                  <img src={resolveFederationLogo(f)} alt={f.name} className="h-12 w-12 sm:h-14 sm:w-14 object-contain shrink-0" />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-2">
                      <div className="font-display font-semibold text-sm sm:text-base truncate">{f.name}</div>
                      {f.is_copf && <Badge className="bg-[hsl(var(--aito-gold))] text-black shrink-0 text-[10px]">COPF</Badge>}
                    </div>
                    <div className="text-xs text-muted-foreground mt-1 truncate">{f.discipline || "Pluri-disciplines"}</div>
                  </div>
                </Card>
              </Link>
            ))}
          </div>}
      </div>
    </div>
  );
}
